import { render } from "./EWasteErrors.vue?vue&type=template&id=465b5880"
import script from "./EWasteErrors.vue?vue&type=script&lang=js"
export * from "./EWasteErrors.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__